import packageJson from '../../package.json';

export const environment = {
  production: false,
  version: packageJson.version,
  mock: false,
  type: 'QA',
  subDomainSeparator: '-',
  translationTags: ['STXPublic'],

  // App backend API base url
  serviceUrl: '/api',

  auth: {
    mock: false,
    baseUrl: '',
    loginUrlPath: '/connect/authorize',
    profileUrlPath: '/#/my-account/tickets',
    logoutUrlPath: '/connect/endsession',
    login: {
      redirect_uri: '#/auth',
      response_type: 'token',
      grant_type: 'implicit',
      scope: 'api',
      client_id: 'public_client',
    },
    adminLogin: {
      redirect_uri: 'https://qa.stx.interticket.com/#/auth/login?',
      response_type: 'token',
      grant_type: 'implicit',
      scope: 'api',
      client_id: 'admin_client',
    },
  },

  // Mux config
  mux: {
    env_key: 'm38o7a78ju71d6hc4057n3den',
  },

  // Service settings
  modules: {
    core: {
      event: { version: 'v1', mock: false },
      venue: { version: 'v1', mock: false },
      translate: { version: 'v1', mock: false },
      media: { version: 'v1', mock: false },
      partner: { version: 'v1', mock: false },
      regionPartner: { version: 'v2', mock: false },
      cart: { version: 'v1', mock: false },
      customer: { version: 'v1', mock: false },
      productCatalog: { version: 'v1', mock: false },
      payment: { version: 'v1', mock: false },
      iam: { version: 'v2', mock: false },
      card: { version: 'v1', mock: false },
    },
  },

  // Google apps settings
  google: {
    // GoogleMaps
    maps: { key: 'AIzaSyBAJyF_SyDzkmeUcbMt8Fqcyd7ByfvaWYs' },
    // Analytics
    analytics: {
      oplevbrondby: 'UA-158856264-1',
      aarhusbryghus: 'UA-158856264-1',
      beghuset: '',
      interticket: '',
      pfz: '',
      lisztacademy: '',
      varketbazar: '',
      operett: '',
      pbest: '',
      tulipantunder: '',
      atrium: '',
      uranianf: '',
      csanyisandorprodukcio: '',
      dumaszinhaz: '',
      szegediszabadteri: '',
      szigligetiszinhaz: '',
      pestimagyarszinhaz: '',
      budapestbabszinhaz: '',
      operaotthonra: '',
      virtuozok: '',
      hagyomanyokhaza: '',
      fonobudaizenekar: '',
      gyoribalett: '',
      klezmer: '',
      bekescsabaijokai: '',
      veres1szinhaz: '',
      pannoniaentertainment: '',
      b32: '',
      roxinhaz: '',
      jaszaimari: '',
      trafo: '',
      tudomanyosstandup: '',
      obidaidanubia: '',
      kodalyfilharmonia: '',
      gyorinemzeti: '',
      fovarosinagycirkus: '',
      budapestjazz: '',
      budafokidohnanyi: '',
      budaorsijmmh: '',
      hatszin: '',
      quimby: '',
      bagossy: '',
      nemzetitancszinhaz: '',
      szegedinemzeti: '',
      vigszinhaz: '',
      mozgomozi: '',
      dunatancmuhely: '',
      szkene: '',
      pindroch: '',
      soltis: '',
      csanyisandorprodukciozart: '',
    },
    // TagManager
    tagManager: {
      oplevbrondby: '',
      aarhusbryghus: '',
      beghuset: '',
      interticket: '',
      operett: '',
      pbest: '',
      tulipantunder: '',
      atrium: '',
      uranianf: '',
      csanyisandorprodukcio: '',
      dumaszinhaz: '',
      szegediszabadteri: '',
      szigligetiszinhaz: '',
      pestimagyarszinhaz: '',
      budapestbabszinhaz: '',
    },
  },

  // Log settings
  logging: {
    stackdriver: {
      apiKey: 'AIzaSyCRo7Sj4k4Scq-1QfyNhjheMx4CmhQEfVg',
      projectId: 'stemx-228313',
      disabled: false,
    },
    slack: {
      logWebhookUrl: 'https://hooks.slack.com/services/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',
    },
  },

  // Crisp
  crisp: {
    websiteId: '55cff766-ea7f-4a90-a0ec-2f2a22faa919',
  },

};

